var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.$route.params.action === 'editar')?_c('div',[_c('edit-company')],1):_vm._e(),(_vm.$route.params.action === 'ver')?_c('div',[_c('view-company')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }